import type { ParseOptions } from '@noths/polaris-product-listings-urls';

import { safeCanonicalPath } from 'src/utils/safeCanonicalPath';

/**
 * The case-insensitive equality key for a taxonomy URL: its canonical path
 * (drops query/fragment, canonical filter ordering and encoding), lower-cased so
 * matching ignores case. Two URLs denote the same page iff their match keys are
 * equal. Returns `null` when the URL cannot be parsed under `options` (so it can
 * never match an entry), rather than throwing.
 */
export const toMatchKey = (url: string, options: ParseOptions): string | null =>
  safeCanonicalPath(url, options)?.toLowerCase() ?? null;
